<template>
  <div>
    <nav
      role="navigation"
      aria-label="main navigation"
      class="navbar is-fixed-top has-shadow"
    >
      <div class="navbar-brand">
        <a href="#/" class="navbar-item router-link-active"
          ><img src="@/assets/logo.svg"
        /></a>
      </div>
      <div class="navbar-end mr-5">
        <div class="localization">
          <dropdown class="is-down" :open.sync="dropdown">
            <a
              slot="v"
              class="button is-fullwidth language"
              aria-haspopup="true"
            >
              <img :src="language.icon" alt="" /> {{ language.name }}
            </a>

            <a
              v-for="lang in languages"
              :key="lang.name"
              class="dropdown-item language"
              @click.prevent="localize(lang)"
            >
              <img :src="lang.icon" alt="" /> {{ lang.name }}
            </a>
          </dropdown>
        </div>
      </div>
    </nav>
    <section class="hero is-fullheight" style="margin-top: 3.25rem">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            {{ $l("components.download.instructions", "Instructions") }}
          </h1>
          <box>
            <div slot="header">
              <div class="columns is-vcentered">
                <div class="column">
                  {{
                    $l(
                      "components.download.howTo",
                      "How to install CyRadar Endpoint Security"
                    )
                  }}
                </div>
                <div class="column is-narrow download-dropdown">
                  <dropdown class="is-down" :open.sync="downloadDropdown">
                    <button
                      slot="v"
                      class="button is-info"
                      aria-haspopup="true"
                      style="
                        margin-right: 10px;
                        height: 2.2em;
                        font-weight: normal;
                      "
                    >
                      {{ $l("components.login.downloadCyES") }}
                    </button>
                    <div style="margin: auto; width: 80%">
                      <div class="columns">
                        <div class="column">
                          <div class="field">
                            <label class="label">{{
                              $l("components.download.os", "Operating system")
                            }}</label>
                          </div>

                          <div class="control">
                            <v-select
                              v-model="formDownload.os"
                              label="name"
                              :reduce="(option) => option.name"
                              :clearable="false"
                              :options="listOS"
                            >
                              <template #option="{ description }">
                                <span>{{ `${description}` }}</span>
                              </template>

                              <template #selected-option="{ description }">
                                <span>{{ `${description}` }}</span>
                              </template>
                            </v-select>
                          </div>
                        </div>
                      </div>

                      <div
                        slot="footer"
                        class="field is-grouped is-grouped-right"
                      >
                        <div class="control">
                          <button
                            class="button"
                            @click.prevent="downloadDropdown = false"
                          >
                            {{ $l("global.close", "Close") }}
                          </button>
                        </div>
                        <div class="control">
                          <button
                            class="button is-info"
                            @click.prevent="
                              downloadInstallerOnline(formDownload)
                            "
                          >
                            {{ $l("global.downloadDown", "Download") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </dropdown>
                </div>
              </div>
            </div>
            <!-- <div>
              <strong>{{ $l("components.download.step", "Step") }} 1: </strong>
              <span>
                {{ $l("components.download.download", "Download") }}
                <a
                  href="/api/v1/view/download/agents/CyRadarEndpointSecurityOnlineSetup.exe"
                  >{{
                    $l(
                      "components.download.installer",
                      "CyRadar Endpoint Security installer"
                    )
                  }}</a
                >
              </span>
            </div> -->
            <div>
              <div>
                <strong
                  >{{ $l("components.download.step", "Step") }} 1:
                </strong>
                <span>{{
                  $l(
                    "components.download.doubleClick",
                    "Double click the recently downloaded file, the installer will start."
                  )
                }}</span>
              </div>
              <br> 
              <img
                style="display: block; margin: auto; max-width: 500px"
                src="@/assets/installer-win-01.png"
              />
              <div>
                <strong
                  >{{ $l("components.download.step", "Step") }} 2:
                </strong>
                <span>{{
                  $l(
                    "components.download.fillInfo",
                    "Fill the infomation as required"
                  )
                }}</span>:
              </div>
              <br> 
              <img
                style="display: block; margin: auto; max-width: 500px"
                src="@/assets/installer-win-03.png"
              />
              <ul>
                <li>
                  <strong
                    >{{
                      $l("components.download.serverAddress", "Server address")
                    }}:
                  </strong>
                  {{
                    $l(
                      "components.download.serverAddressExplain",
                      "the address of the local CyRadar server. If there isn't any instructions from administrator, you can use"
                    )
                  }}
                  "<strong>{{ hostname }}</strong
                  >".
                </li>
                <li>
                  <strong
                    >{{ $l("components.download.port", "Port") }}:
                  </strong>
                  {{
                    $l(
                      "components.download.portExplain",
                      "the port of the local CyRadar server. If there isn't any instructions from administrator, you can use"
                    )
                  }}
                  "<strong>443</strong>".
                </li>
                <li>
                  <strong
                    >{{ $l("components.download.license", "License") }}:
                  </strong>
                  {{
                    $l(
                      "components.download.licenseExplain",
                      "the license code used to verify and classify agent. Contact your administrator for this."
                    )
                  }}
                </li>
                <!-- <li>
                  <strong
                    >{{ $l("components.download.contact", "Contact") }}:
                  </strong>
                  {{
                    $l(
                      "components.download.contactExplain",
                      "(optional) The user's contact information."
                    )
                  }}
                </li> -->
              </ul>
              <br> 
              <img
                style="display: block; margin: auto; max-width: 500px"
                src="@/assets/installer-win-06.png"
              />
              <ul>
                <li>
                  <strong
                    >{{ $l("components.download.contact", "Contact") }}:
                  </strong>
                  {{
                    $l(
                      "components.download.contactExplain",
                      "(optional) The user's contact information."
                    )
                  }}
                </li>
              </ul>
            </div>
            <div>
              <strong>{{ $l("components.download.step", "Step") }} 3: </strong>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <span v-html="$t('components.download.pressInstall')" />
              <br> 
              <img
                style="display: block; margin: auto; max-width: 500px"
                src="@/assets/installer-win-07.png"
              />
              <div>
                {{
                  $l(
                    "components.download.beginToInstall",
                    "The installer will auto download required files and begin to install CyRadar Endpoint Security on the computer."
                  )
                }}
              </div>
            </div>
            <div>
              <strong>{{ $l("components.download.step", "Step") }} 4: </strong>
              <span>{{
                $l(
                  "components.download.restartToComplete",
                  "Restart the computer to complete the installation."
                )
              }}</span>
            </div>
          </box>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import DownloadApi from "@/api/Download";
import ServerApi from "@/api/Server";
import vSelect from "vue-select";
import { devServer } from "../../vue.config";

export default {
  name: "Download",
  components: {
    vSelect,
  },

  data() {
    return {
      dropdown: false,
      downloadDropdown: false,

      formDownload: {
        tag: "",
        os: "",
      },

      latestVersion: "",
      listOS: [],
      listTags: [],
    };
  },

  computed: {
    hostname() {
      return window.location.hostname;
    },
    language() {
      return this.$store.getters.currentLanguage;
    },
    languages() {
      return this.$store.getters.languages
        .filter((language) => {
          return language.locale !== this.language.locale;
        })
        .slice();
    },
  },
  methods: {
    localize(language) {
      this.dropdown = false;
      this.$store.dispatch("LOCALIZE", language);
    },

    async fetchOS() {
      await DownloadApi.getOSList(this.$http).then((data) => {
        let osData = data;
        this.listOS = osData.map((os) => {
          return {
            name: os.name,
            description: os.description,
          };
        });
      });
      this.formDownload.os = this.listOS[0].name;
    },

    downloadInstallerOnline(form) {
      const currentURL = window.location.protocol + "//" + window.location.host;
      DownloadApi.downloadInstallerOnline(this.$http, form.os).then((res) => {
        const downloadTab = window.open(currentURL + res.url, "_blank");
        downloadTab.addEventListener("load", () => {
          downloadTab.close();
        });
      });
    },
  },

  mounted() {
    this.fetchOS();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .navbar .dropdown.is-right .dropdown-menu {
  right: 0;
  min-width: 0px;
  width: 100%;
}

.navbar-end {
  width: 10rem;
}

.localization {
  display: flex;
  align-items: center;
  border-top: 0;
  width: 100%;
}

ul {
  display: block;
  list-style-type: disc;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

/deep/ .download-dropdown .dropdown.is-right .dropdown-menu {
  right: 0;
  min-width: 500px;
  width: 100%;
}
</style>

<style src="vue-select/dist/vue-select.css"></style>
